import { useEffect, useState, useRef } from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import "../../../stili/tabelle.css";
import "../../../stili/popup.css";
import "../../../stili/tabs.css"
import convertDate from "../../../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../../../funzioni/nome_id.js"
import {
    convertiIdNoleggio,
    convertiIdInventario,
    materialeDisponibile,
    analisiMateriale,
    sovrapposti,
    ordinaPerData,
    convertiTipoStorage,
    convertiValuta
} from "../../../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser,
    faUsers,
    faPencil,
    faTrashCan,
    faCircleInfo,
    faSpinner,
    faFileInvoice
} from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import {noleggi_off,utenti_off} from "../../../offline/offline_costanti.js";
/* global $ */
/* global DevExpress */

function StorageStorico() {
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
function DynamicLessonButton2({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);
     console.log(cellInfo)
     if (!cellInfo.data.invoiceid) {
         const content = generaInterfacciaFattura(cellInfo.data)
         $("#fattura").dxPopup("instance").option(
             "title",
             `Fattura`
         );
         $("#fattura").dxPopup("instance").option("contentTemplate", () => content);
         $("#fattura").dxPopup("instance").show();
         $("#fattura").dxPopup("instance").option("toolbarItems", [{
             widget: 'dxButton',
             toolbar: 'bottom',
             location: 'after',
             options: {
                 stylingMode: 'contained',
                 text: 'Salva',
                 onClick: async function () {
                     let intestazioniR = $("#intestazione").dxDataGrid("instance").option("dataSource")[0]
                     delete intestazioniR["__KEY__"]
                     let totalePagato = 0
                     let totale = 0
                     let righe = $("#righe").dxDataGrid("instance").option("dataSource")
                     for (let riga of righe) {
                         totale += riga.invoicerownettotvalue
                         totalePagato += riga.pagato
                     }
                     intestazioniR["invoicedate"] = DateTime.fromISO(intestazioniR["invoicedate"]).toFormat("yyyyMMdd")
                     intestazioniR["invoicenetvalue"] = totale
                     intestazioniR["invoicegrossvalue"] = totale
                     intestazioniR["invoiceadvance"] = totalePagato
                     intestazioniR["invoicetopay"] = totale - totalePagato

                     let richiestaFattura = await funzione_collegamento({
                         userid: getUserId(),
                         token: getToken(),
                         logout_on_error: true,
                         valori: intestazioniR,
                         azione: 'setInvoice'
                     })
                     const idFattura = richiestaFattura.invoiceid
                     let richiestaRiga
                     for (let riga of righe) {
                         delete riga.__KEY__
                         riga["invoiceid"] = idFattura
                         richiestaRiga = await funzione_collegamento({
                             userid: getUserId(),
                             token: getToken(),
                             logout_on_error: true,
                             valori: riga,
                             azione: 'setInvoiceRow'
                         })
                     }
                     const fatturaRich = await funzione_collegamento({
                         userid: getUserId(),
                         token: getToken(),
                         logout_on_error: true,
                         filtri: {getid: idFattura},
                         azione: 'generateInvoice'
                     })
                     if (!$("#bottoneSalva").dxCheckBox("instance").option("value")) {
                         richiestaFattura = await funzione_collegamento({
                             userid: getUserId(),
                             token: getToken(),
                             logout_on_error: true,
                             delId: idFattura,
                             azione: 'delInvoice'
                         })
                     }
                     else{
                         const rich=await funzione_collegamento({
                           userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            setId:cellInfo.data.storageid,
                            valori: {invoiceid:idFattura},
                            azione:'setStorage'})
                         const dati = await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"storagesfrom":inizioP,"storagesTo":fineP},
                        azione: "getStorages",
                    })
                    const formattedRows=dati.map((row,index) => ({
                id:index,
                storageid:row.storageid,
                data:convertDate(row.storageregdate).toISO({ includeOffset: false }),
                nome:row.storagecustname,
                tipo:row.storagetype,
                storageDa:convertDate(row.storagefrom).toISO({ includeOffset: false }),
                storageA:convertDate(row.storageto).toISO({ includeOffset: false }),
                costo:row.storagecost,
                pagato:row.storageadvance,
                metodo:row.storagepaymentmethod,
                telefono:row.storagecustphone,
                residenza:row.storagecustresidence,
                sconto:row.storagediscount,
                rescuePagati:row.storageprepaidrescues,
                rescueUsati:row.storageusedrescues,
                costo_scontato:(row.storagecost * (1 - (row.storagediscount || 0) / 100)),
                conto:row.billid,
            }))
                      $("#gridContainerStorages").dxDataGrid("instance").option("dataSource",formattedRows)

                     }
                     const baseURL = "https://jckite.mogaverocompany.co.ke";
                     const fileURL = fatturaRich.pdffilename ? fatturaRich.pdffilename.startsWith("http")
                         ? fatturaRich.pdffilename
                         : `${baseURL}${fatturaRich.pdffilename.startsWith("/") ? "" : "/"}${fatturaRich.pdffilename}` : "";
                     window.open(fileURL, "_blank");
                 }
             }
         }, {
             widget: 'dxButton',
             toolbar: 'bottom',
             location: 'after',
             options: {
                 text: 'Chiudi',
                 stylingMode: 'outlined',
                 type: 'normal',
                 onClick() {
                     $("#fattura").dxPopup("instance").hide();
                 },
             },
         }],)
         $("#loadingOverlay").hide();
         setLoading(false);
     }
     else{
         const baseURL = "https://jckite.mogaverocompany.co.ke";
         const url1=await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        filtri:{getid:cellInfo.data.invoiceid},
        azione:'getInvoice'
      });
         const url=url1[0]
         const fileURL = url.invoicepdf?url.invoicepdf.startsWith("http")
            ? url.invoicepdf
            : `${baseURL}${url.invoicepdf.startsWith("/") ? "" : "/"}${url.invoicepdf}`:"";
         window.open(fileURL, "_blank")
     }
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faFileInvoice}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}
function generaInterfacciaFattura(dati){
    const allineamento="center"
    const divGen=document.createElement("div")
    const divSalva=document.createElement("div")
    divSalva.id="bottoneSalva"
    divSalva.style.marginTop="10px"
    divGen.appendChild(divSalva)
    const divIntest=document.createElement("div")
    divIntest.id="intestazione"
    const divRighe=document.createElement("div")
    divRighe.id="righe"
    divGen.appendChild(divIntest)
    divGen.appendChild(divRighe)
    let righe=[]
    let quantita={}
    console.log(dati)
    let giorniTot=DateTime.fromISO(dati.storageA).diff(DateTime.fromISO(dati.storageDa)).as('days')
    if (!(`${giorniTot} ${dati.tipo}` in quantita)) quantita[`${giorniTot} ${dati.tipo}`]={"costo":0,"quantita":0,"durata":0,"pagato":0}
    quantita[`${giorniTot} ${dati.tipo}`]["quantita"]+=1
    quantita[`${giorniTot} ${dati.tipo}`]["costo"]+=dati.costo_scontato
    quantita[`${giorniTot} ${dati.tipo}`]["pagato"]+=dati.pagato
    for (let durata in quantita){
        const [a, b] = durata.split(" ").map(Number);
        righe.push({"invoicerowdescr":`${a} ${a===1?"day":"days"} ${convertiTipoStorage(b)}`,"pagato":quantita[durata]["pagato"],"invoicerowcurrency":1,"invoicerowquant":quantita[durata]["quantita"],"invoicerownetunitvalue":quantita[durata]["costo"]/quantita[durata]["quantita"],"invoicerownettotvalue":quantita[durata]["costo"],"invoicerowgrosstotvalue":quantita[durata]["costo"]})
    }
    setTimeout(()=> {
        $("#bottoneSalva").dxCheckBox({
            text:"Salva fattura",
            value:false,
        })
        $("#intestazione").dxDataGrid({
            dataSource:[],
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: "Modifica intestazione",
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
            columns: [
             { dataField: "invoicecustomer", alignment:allineamento,caption: "Nome Fattura",hidingPriority:9},
          {
            dataField: "invoicedate",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg_int").length===0) {
                $('<div id="val_reg_int"></div>').appendTo(cellElement)
            }
            $("#val_reg_int").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
            { dataField: "invoiceaddress", alignment:allineamento,caption: "Indirizzo cliente",hidingPriority:2,
        },
            { dataField: "invoicecontacts", alignment:allineamento,caption: "contatti cliente",hidingPriority:3,
        },
        { dataField: "invoicenotes", alignment:allineamento,caption: "Note fattura",hidingPriority:1,
        },
            { dataField: "invoicenumber", alignment:allineamento,caption: "Numero fattura",hidingPriority:4,
        },
            {dataField:"invoicecurrency",
            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }},

          {
            type: "buttons",
            minWidth:140,
            buttons: [

              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },

              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
        })
        $("#righe").dxDataGrid({
            dataSource:righe,
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: "Modifica righe",
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
             columns:[
                {"dataField":"invoicerowdescr","caption":"Descrizione", hidingPriority:5},
                {"dataField":"invoicerowquant",caption:"Quantità",hidingPriority:2,
                editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_quantita_righe").length===0) {
                $('<div id="val_quantita_righe"></div>').appendTo(cellElement)
            }
            $("#val_quantita_righe").dxNumberBox({value:cellInfo.value,minValue:0,onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_unitario").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                { dataField: "invoicerowcurrency",visible:false, caption: "Valuta",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_netto").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_unitario").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_gross").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)

            }})
          },
        },
                {"dataField":"invoicerownetunitvalue","caption":"Costo unitario",hidingPriority:3,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_unitario").length===0) {
                $('<div id="val_unitario"></div>').appendTo(cellElement)
            }
            $("#val_unitario").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_quantita_righe").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                {"dataField":"invoicerownettotvalue","caption":"Costo netto totale",hidingPriority:4,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_netto").length===0) {
                $('<div id="val_netto"></div>').appendTo(cellElement)
            }
            $("#val_netto").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

                {"dataField":"pagato","caption":"Pagato",hidingPriority:1,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_pag_in").length===0) {
                $('<div id="val_pag_in"></div>').appendTo(cellElement)
            }
            $("#val_pag_in").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

            ],
            columnAutoWidth: true,
        columnHidingEnabled: true,
        })

    },0)
    return divGen

}
 function openContoFormPopup(initialData, aggiunta) {
  const popup = $("#popupContoEdit").dxPopup("instance");

  popup.option("contentTemplate", function() {
    const container = $("<div>");
    container.dxForm({
      formData: initialData,
      labelLocation: "top",
      items: [
         {
      dataField: "data",
      label: { text: "Data" },
      template: function(formItem, itemElement) {
        itemElement.empty();

        // Converto il valore iniziale in Date se è ISO:
        let initialValue = formItem.editorOptions?.value || formItem.component.option("formData").data;
        if (typeof initialValue === "string") {
          initialValue = new Date(initialValue);
        }

        $("<div>").appendTo(itemElement).dxDateBox({
          type: "date",
          displayFormat: "dd/MM/yyyy",
          value: initialValue,
          onValueChanged: function(e) {
             const form = formItem.component; // usa il componente passato
    const fd = form.option("formData");
    fd.data = e.value ? e.value.toISOString().slice(0,10) : null;
    form.option("formData", fd);
          }
        });
      }
    },
          { dataField: "nome" },
        { dataField: "note" },

        {
          itemType: "button",
          horizontalAlignment: "right",
          buttonOptions: {
            text: "Salva",
            type: "success",
            onClick: async function() {
              const form = container.dxForm("instance");
              const data = form.option("formData");
              let richiesta;
              const dati= {billcustomer:data.nome,billdate:convertDate(DateTime.fromISO(data.data)),
                billnotes:data.note}
              if (aggiunta){
                   richiesta = await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                        azione:'setBillItem'
                   })
                  const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.push({id:richiesta.billid,text:data.nome})
                  instance.option("dataSource",datas)
              }
              else {
                  richiesta= await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                      setId:$("#val_conto").dxLookup("instance").option("value"),
                        azione:'setBillItem'
                   })
                    const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.find(x => {
                        if (x.id === instance.option("value")) x.text=data.nome
                    })
                  instance.option("dataSource",datas)
              }
              popup.hide();
            }
          }
        }
      ]
    });
    return container;
  });

  popup.show();
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStoricoStorage() {
    const tipoStorag=[{id:1,text:"Storage"},{id:2,text:"Storage + 3 rescue"},{id:3,text:"Assistenza spiaggia"}]
    const allineamento="center"
    useEffect(() => {
        const fetchStorages = async () => {
            $("#gridContainerStorages").addClass("grid-container-hidden")
            $("#loadingOverlay").show()
            const dati = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                filtri:{"storagesfrom":inizioP,"storagesto":fineP},
                azione: "getStorages",
            })
            const conti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBillItems",
            })

            const formattedRows=dati.map((row,index) => ({
                id:index,
                storageid:row.storageid,
                data:convertDate(row.storageregdate).toISO({ includeOffset: false }),
                nome:row.storagecustname,
                tipo:row.storagetype,
                durata:Math.floor((convertDate(row.storageto)-convertDate(row.storagefrom))/(60*60000*24)),
                storageDa:convertDate(row.storagefrom).toISO({ includeOffset: false }),
                storageA:convertDate(row.storageto).toISO({ includeOffset: false }),
                costo:row.storagecost,
                pagato:row.storageadvance,
                metodo:row.storagepaymentmethod,
                telefono:row.storagecustphone,
                residenza:row.storagecustresidence,
                sconto:row.storagediscount,
                rescuePagati:row.storageprepaidrescues,
                rescueUsati:row.storageusedrescues,
                costo_scontato:(row.storagecost * (1 - (row.storagediscount || 0) / 100)),
                conto:row.billid,
            }))
            $("#gridContainerStorages").dxDataGrid({

          dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: "Data",

            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "nome", caption: "Nome", hidingPriority: 12,alignment:allineamento, },
              {
                dataField: "conto",visible:false,
                editCellTemplate: function (cellElement,cellInfo){
            if ($("#val_conto").length===0) {
                $('<div id="val_conto"></div>').appendTo(cellElement)
            }
             let selectBoxData = conti.map(name => ({ id: name.billid, text: name.billcustomer }));

            $("#val_conto").dxLookup({
  dataSource: selectBoxData,
  valueExpr: "id",
  displayExpr: "text",
  value: cellInfo.value,
  searchEnabled: true,
  showClearButton: true,
  placeholder: "Seleziona...",
  onValueChanged: function (e) {
    cellInfo.setValue(e.value);
  },

  // ---> QUI AGGIUNGIAMO I BOTTONI <---
  fieldTemplate: function (selectedItem, container) {
    const valueText = selectedItem ? selectedItem.text : "";

    const wrapper = $("<div>").css({
      display: "flex",
      alignItems: "center",
      width: "100%"
    });

    // Testo del lookup
    $("<span>")
      .text(valueText)
      .css({ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis" })
      .appendTo(wrapper);

    const instance = $("#val_conto").dxLookup("instance");

    // Funzione helper blocca apertura popup
    const stop = (e) => e.stopPropagation();

    // BTN MODIFICA
    $("<i class='fa-solid fa-pencil' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("MODIFICA → id:", val);
          // dentro onClick della matita
const id = instance.option("value");

const conto = conti.find(x => x.billid === id);

openContoFormPopup(
  conto?{nome:conto.billcustomer,data:convertDate(conto.billdate).toISO({includeOffset:false}),
                note:conto.billnotes}: {nome:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false}),
                note:""},false)
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter modificare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    // BTN AGGIUNGI
    $("<i class='fa-solid fa-plus' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        console.log("AGGIUNGI → apri popup nuovo");
        openContoFormPopup(
  { nome: "", note:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false})}, true)
      })
      .appendTo(wrapper);

    // BTN ELIMINA
    $("<i class='fa-solid fa-trash-can' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("ELIMINA → id:", val);
          // TUO CODICE QUI
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter eliminare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    container.empty().append(wrapper);
  }
});

            },
            },
          { dataField: "tipo", caption: "Tipo storage", hidingPriority: 6,alignment:allineamento,
              customizeText: function (cellInfo) {
                return convertiTipoStorage(cellInfo.value)
              },
              editCellTemplate: function(cellElement,cellInfo) {
                  if ($("#val_tipo").length===0) {
                      $('<div id="val_tipo"></div>').appendTo(cellElement)
                  }

                  $("#val_tipo").dxSelectBox({dataSource:tipoStorag,valueExpr: 'id',displayExpr: 'text',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
                    cellInfo.setValue(e.value)
                    },
                  })
              }
          },
          {
            dataField: "storageDa",
            caption: "Storage da",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_inizio").length===0) {
                $('<div id="val_inizio"></div>').appendTo(cellElement)
            }
            $("#val_inizio").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            const fine=DateTime.fromISO($("#val_fine").dxDateBox("instance").option("value"))
            const inizio=DateTime.fromISO(e.value)
            const durata=(fine-inizio)/(60*60000*24)
            var minuti=durata%60
            $("#val_durata").dxNumberBox("instance").option("value",durata)
            }})
          },
            hidingPriority: 10,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          {
            dataField: "storageA",
            caption: "Storage a",

            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_fine").length===0) {
                $('<div id="val_fine"></div>').appendTo(cellElement)
            }
            $("#val_fine").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            let fine=null
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
              fine=DateTime.fromJSDate(e.value)
            }
            else {
                cellInfo.setValue(e.value)
                fine=DateTime.fromISO(e.value)
            }
            const inizio=DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value"))

            const durata=(fine-inizio)/(60*60000*24)
           $("#val_durata").dxNumberBox("instance").option("value",durata)
            }})
          },
            hidingPriority: 8,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          {
            dataField: "costo",
            caption: "Costo",
            alignment:allineamento,
            hidingPriority: 11,
            calculateDisplayValue: function(rowData) {
    return rowData.costo_scontato ?? rowData.costo;
  },
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo").length===0) {
                $('<div id="val_costo"></div>').appendTo(cellElement)
            }
            $("#val_costo").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const sconto_att=$("#val_sconto").dxNumberBox("instance").option("value")
            $("#val_costo_scontato").dxNumberBox("instance").option("value",cellInfo.value*(1-sconto_att/100))

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          {
            dataField: "pagato",
            caption: "Anticipo",
            hidingPriority: 9,
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_anticipo").length===0) {
                $('<div id="val_anticipo"></div>').appendTo(cellElement)
            }
            $("#val_anticipo").dxNumberBox({min:0,value:cellInfo.value,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} €`;
            }
          },
          { dataField: "metodo", caption: "Pagamento", hidingPriority: 5,alignment:allineamento, },
          {dataField: "sconto",visible:false,editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_sconto").length===0) {
                $('<div id="val_sconto"></div>').appendTo(cellElement)
            }
            $("#val_sconto").dxNumberBox({showSpinButtons: true,step:5,min:0,value:cellInfo.value,max:100,format:"#0.##'%'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const valore_nuovo=($("#val_costo").dxNumberBox("instance").option("value"))*(1-cellInfo.value/100)
            $("#val_costo_scontato").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }},
          {dataField: "costo_scontato",visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_costo_scontato").length===0) {
                $('<div id="val_costo_scontato"></div>').appendTo(cellElement)
            }

            const displV=($("#val_costo").dxNumberBox("instance").option("value"))*(1-($("#val_sconto").dxNumberBox("instance").option("value"))/100)
            $("#val_costo_scontato").dxNumberBox({showSpinButtons: true,step:10,min:0,value:displV,format:"#0.##'€'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_costo_scontato").dxNumberBox("instance").option("max",$("#val_costo").dxNumberBox("instance").option("value"))
            const valore_nuovo=(1-(e.value)/($("#val_costo").dxNumberBox("instance").option("value")))*100
            $("#val_sconto").dxNumberBox("instance").option("value",valore_nuovo)
            }})
          }
          },
          { dataField: "telefono", caption: "Numero cliente", hidingPriority: 4,alignment:allineamento, },
          { dataField: "residenza", caption: "Residenza cliente", hidingPriority: 3,alignment:allineamento, },
          { dataField: "rescuePagati", caption: "Rescue pagati", hidingPriority: 2,alignment:allineamento, },
          { dataField: "rescueUsati", caption: "Rescue usati", hidingPriority: 1,alignment:allineamento, },
          { dataField: "durata", visible: false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_durata").length===0) {
                $('<div id="val_durata"></div>').appendTo(cellElement)
            }
            $("#val_durata").dxNumberBox({min:0,value:cellInfo.value,format:"#' giorni'", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const durationString = e.value;
            const valoreInMs = durationString*60*60000*24
            const fine=DateTime.fromMillis(DateTime.fromISO($("#val_inizio").dxDateBox("instance").option("value"))+valoreInMs).toISO({includeOffset:false})
            $("#val_fine").dxDateBox("instance").option("value",fine)

            }})
          },
            customizeText: function (e) {
              const val = typeof e.value === 'number' ? e.value : 0;
              return `${val.toFixed(2)} giorni`;
            }
          },
          {
            type: "buttons",
            minWidth:160,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
                {
                  hint: "Fattura pacchetto",
                  icon: "none",
                  template: function (cellElement, cellInfo) {
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(<DynamicLessonButton2 cellInfo={cellInfo} />);
                  },
                },
            ],
          },
          ],
          showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica storage",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form: {
  colCount: 1,  // Tutti gli elementi a tutta larghezza
  items: [
    {
      itemType: "group",
      colCount: 2,
      items: ["data", "nome"],
    },
    {
      itemType: "group",
      colCount: 3,
      items: [
        { dataField: "storageDa", label: { text: "Storage da" } },
        { dataField: "storageA", label: { text: "Storage a" } },
        {dataField: "durata", label: { text: "Durata storage" } }
      ],
    },
    {
      itemType: "group",
      colCount: 2,
      items: [
        { dataField: "tipo", label: { text: "Tipo Storage" } },
        { dataField: "costo", label: { text: "Costo (€)" } },
        { dataField: "pagato", label: { text: "Pagato (€)" } },
        { dataField: "metodo", label: { text: "Metodo di pagamento" } },
        { dataField: "telefono", label: { text: "Numero cliente" } },
        { dataField: "residenza", label: { text: "Residenza cliente" } },
        { dataField: "rescuePagati", label: { text: "Rescue pagati" } },
        { dataField: "rescueUsati", label: { text: "Rescue usati" } },
        { dataField: "sconto", label: { text: "Sconto (%)" } },
        { dataField: "costo_scontato", label: { text: "Costo scontato" } },
        { dataField: "conto", label: { text: "Conto" } },
      ],
    },
  ],
}

        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && (e.dataField === "data"||e.dataField === "storageDa"||e.dataField==="storageA")) {

            e.editorName = "dxDateBox";  // Forza DateBox come filtro
            e.editorOptions = {
              displayFormat: "dd/MM/yyyy",
              type: "date",
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
            const dataTipo=tipoStorag
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'id',displayExpr: 'text',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
        },
        onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        e.data.sconto=0;
        e.data.data=DateTime.now().toISODate()
        e.data.storageDa=DateTime.now().toISODate()
        e.data.rescueUsati=0
        e.data.tipo=1
        },
        onRowInserting: async function (e) {
            const gridElement = $("#gridContainerStorages"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            console.log(convertDate(DateTime.fromISO(e.data.storageDa)),e.data.storageDa)
            const dati_n={"billid":e.data.conto?e.data.conto:0,'storagediscount':e.data.sconto,'storagecustname':e.data.nome,'storagetype':e.data.tipo,'storagecost':e.data.costo,'storageadvance':e.data.pagato,'storagepaymentmethod':e.data.metodo,"storagecustphone":e.data.telefono,"storagecustresidence":e.data.residenza,"storagefrom":convertDate(DateTime.fromISO(e.data.storageDa)),"storageto":convertDate(DateTime.fromISO(e.data.storageA)),"storageregdate":convertDate(DateTime.fromISO(e.data.data)),"storageprepaidrescues":e.data.rescuePagati,"storageusedrescues":e.data.rescueUsati};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setStorage'})
                if (richiesta) {
                    const message = `Storage di ${e.data.nome} aggiunto con successo`;
                    window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerStorages',

                        },}, "success", 500);
                    const dati = await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"storagesfrom":inizioP,"storagesTo":fineP},
                        azione: "getStorages",
                    })
                    const formattedRows=dati.map((row,index) => ({
                id:index,
                storageid:row.storageid,
                data:convertDate(row.storageregdate).toISO({ includeOffset: false }),
                nome:row.storagecustname,
                tipo:row.storagetype,
                storageDa:convertDate(row.storagefrom).toISO({ includeOffset: false }),
                storageA:convertDate(row.storageto).toISO({ includeOffset: false }),
                costo:row.storagecost,
                pagato:row.storageadvance,
                metodo:row.storagepaymentmethod,
                telefono:row.storagecustphone,
                residenza:row.storagecustresidence,
                sconto:row.storagediscount,
                rescuePagati:row.storageprepaidrescues,
                rescueUsati:row.storageusedrescues,
                costo_scontato:(row.storagecost * (1 - (row.storagediscount || 0) / 100)),
                conto:row.billid,
            }))
                      $("#gridContainerStorages").dxDataGrid("instance").option("dataSource",formattedRows)
                }

        },
        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerStorages"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            const dati_n={"billid":e.data.conto?e.data.conto:0,'storagediscount':e.data.sconto,'storagecustname':e.data.nome,'storagetype':e.data.tipo,'storagecost':e.data.costo,'storageadvance':e.data.pagato,'storagepaymentmethod':e.data.metodo,"storagecustphone":e.data.telefono,"storagecustresidence":e.data.residenza,"storagefrom":convertDate(DateTime.fromISO(e.data.storageDa)),"storageto":convertDate(DateTime.fromISO(e.data.storageA)),"storageregdate":convertDate(DateTime.fromISO(e.data.data)),"storageprepaidrescues":e.data.rescuePagati,"storageusedrescues":e.data.rescueUsati};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.storageid,
                valori:dati_n,
                azione:'setStorage'})
                if (richiesta) {
                const message = `Storage di ${e.data.nome} modificato con successo`;

                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerStorages',

                        },}, "success", 500);
                }
            },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.storageid,
                azione:'delStorage',
                return_data:false})
            if (richiesta) {
                const message = `Storage di ${e.data.nome} eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerStorages',

                },}, "success", 500);}
        },

        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerStorages").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo_scontato);
            const rescueP = e.data.rescuePagati
            const rescueU=e.data.rescueUsati
            if ((!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01)||(rescueU>rescueP)) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
        },
          })
            $("#popupContoEdit").dxPopup({
  width: "90%",
  height: "auto",
  showTitle: true,
  title: "Gestisci conto",
  dragEnabled: false,
  hideOnOutsideClick: true
});
            $("#fattura").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
 showCloseButton:true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollFattura" style="height: 100%;"></div>');
    $("#customScrollFattura").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });

        }
        fetchStorages()
    },[])
return (<div id="gridContainerStorages" ></div>)
}

return (<div>
        <TabellaStoricoStorage/>
    <div id="popupContoEdit"></div>
    <div id="fattura"/>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}

export default StorageStorico